import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./Dashboard.css";

export default function OrganizationInactiveTrackingPanel() {
  const { t } = useTranslation();

  return (
    <Box className="dashboard-inactive-tracking-panel" role="status">
      <Typography className="dashboard-inactive-tracking-panel-text">
        {t(
          "organizationInactiveTrackingMessage",
          "This organization is inactive. Contact the RouteEye admin to activate it and restore.",
        )}
      </Typography>
    </Box>
  );
}
